import React from 'react'
import RcDialog from 'rc-dialog'
import classNames from 'classnames'
import type { DialogProps as RcDialogProps } from 'rc-dialog'
import Icon from '../icon'
import './index.less'

interface DialogProps extends RcDialogProps {
  centered?: boolean;
}

const Dialog = ({ children, wrapClassName, centered, ...props }: DialogProps) => {
  return <RcDialog 
    closeIcon={<Icon type="m-guanbi" className="fdui-closeIcon" />}
    {...props}
    wrapClassName={classNames(wrapClassName, {'fdui-dialog-wrap-centered': centered})} 
    prefixCls='fdui-dialog'
    transitionName="fdui-dialog-fade"
    >
    {children}
  </RcDialog>
}

export type {
  DialogProps
}

export default Dialog